import { Controller } from "@hotwired/stimulus"
import tippy, { followCursor } from 'tippy.js'


export default class extends Controller {
  tip = null

  static values = {
    text: String,
    appendTo: String,
    followCursor: {type: String, default: 'false'}
  }

  connect() {
    const title = this.element.hasAttribute("title");
    const dataAttr = this.element.hasAttribute("data-tooltip-text-value");
    if(title && !dataAttr) {
      this.element.dataset.tooltipTextValue = this.element.getAttribute("title");
    }
    this.element.removeAttribute("title");
    this.create();
  }

  create() {
    if(!!this.hasTextValue && this.textValue.trim().length > 0) {
      this.tip ??= tippy(this.element, {
        content: this.textValue,
        allowHTML: true,
        appendTo: this.#getNode(this.appendToValue),
        followCursor: this.followCursor,
        plugins: [followCursor]
      });
    }
  }

  textValueChanged() {
    this.create();
    this.tip?.setContent(this.textValue);
  }

  appendToValueChanged() {
    this.tip?.setProps({
      appendTo: this.#getNode(this.appendToValue)
    });
  }

  followCursorValueChanged() {
    this.tip?.setProps({
      followCursor: this.followCursor
    });
  }

  #getNode(selector) {
    let node = null;
    if(selector) {
      node = document.querySelector(selector);
    }

    return node || document.body;
  }

  get followCursor() {
    switch(this.followCursorValue) {
      case 'true':
        return true;
      case 'false':
        return false;
      default:
        return this.followCursorValue;
    }
  }
}
